import { GeneralPermissions } from "@redotech/account-common/permissions";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { RedoMerchantClientContext } from "@redotech/redo-merchant-app-common/client/context";
import { getLocations } from "@redotech/redo-merchant-app-common/client/shopify";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { NotificationBannerItem } from "@redotech/redo-web/arbiter-components/notification/redo-notification-banner";
import { AxiosError } from "axios";
import { useContext, useEffect, useState } from "react";
import { ActionRequiredSeverity } from "./action-required-notification";

export function useLogInToRedo(): {
  severity: ActionRequiredSeverity;
  item: NotificationBannerItem;
} | null {
  const team = useContext(TeamContext);
  const client = useContext(RedoMerchantClientContext);
  const [showBanner, setShowBanner] = useState(false);

  const canAuthenticateWithThirdParties = useHasPermission(
    GeneralPermissions.AUTHENTICATE_WITH_THIRD_PARTIES,
  );

  useEffect(() => {
    if (!team?.shopifyIntegration || !team.storeUrl || !client) {
      return;
    }

    const checkShopifyConnection = async () => {
      try {
        if (!canAuthenticateWithThirdParties) {
          return;
        }
        await getLocations(client, { storeUrl: team.storeUrl });
        setShowBanner(false);
      } catch (error) {
        if (error instanceof AxiosError && error.response?.status === 401) {
          setShowBanner(true);
        }
      }
    };

    void checkShopifyConnection();
  }, [team, client, canAuthenticateWithThirdParties]);

  if (!showBanner) {
    return null;
  }

  return {
    severity: ActionRequiredSeverity.High,
    item: {
      id: "log-in-to-redo",
      type: "error",
      message:
        "Redo is not available to your customers. Please log into Shopify and open Redo from your Apps section.",
      actions: [],
    },
  };
}
